import { Button, Group } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

import { backIcon } from '@assets';

interface BackButtonProps {
  backPath: string | -1;
  replace?: boolean;
  'data-pw'?: string;
}

export const BackButton: React.FC<BackButtonProps> = ({ backPath, replace, 'data-pw': dataPw }) => {
  const navigate = useNavigate();

  return (
    <Group justify="start">
      <Button
        data-pw={dataPw ?? 'back-btn'}
        type="button"
        size="lg"
        p={0}
        variant="transparent"
        onClick={() => {
          navigate(backPath as any, { replace });
        }}
        leftSection={<img src={backIcon} alt="" />}
        color="black"
      >
        Back
      </Button>
    </Group>
  );
};
